"use strict";

var _classCallCheck = require("/home/swain/workspace/mbti/frontend/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/home/swain/workspace/mbti/frontend/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/swain/workspace/mbti/frontend/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/swain/workspace/mbti/frontend/node_modules/@babel/runtime/helpers/inherits");

var _wrapNativeSuper = require("/home/swain/workspace/mbti/frontend/node_modules/@babel/runtime/helpers/wrapNativeSuper");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var UnexpectedError =
/*#__PURE__*/
function (_Error) {
  _inherits(UnexpectedError, _Error);

  function UnexpectedError(errorType) {
    var _this;

    _classCallCheck(this, UnexpectedError);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(UnexpectedError).call(this, errorType.message));
    _this.name = errorType.name;
    _this.stack = new Error().stack;
    _this.info = errorType.info;
    return _this;
  }

  return UnexpectedError;
}(_wrapNativeSuper(Error));

UnexpectedError.EXPECTED_HTML = {
  message: 'Wrong content type header - "text/html" or "application/xhtml+xml" was expected',
  name: 'WRONG_CONTENT_TYPE'
};
UnexpectedError.BAD_OPTIONS = {
  message: 'Bad options (see Opts), options must be an Object',
  name: 'BAD_OPTIONS'
};
exports.default = UnexpectedError;